/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intent_SignalsInputs */

const en_intent_signals = /** @type {(inputs: Intent_SignalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intent Signals`)
};

const es_intent_signals = /** @type {(inputs: Intent_SignalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Señales de intención`)
};

const fr_intent_signals = /** @type {(inputs: Intent_SignalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signaux d'intention`)
};

const de_intent_signals = /** @type {(inputs: Intent_SignalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaufsignale`)
};

const ja_intent_signals = /** @type {(inputs: Intent_SignalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`意図シグナル`)
};

const zh_intent_signals = /** @type {(inputs: Intent_SignalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`意图信号`)
};

const ar_intent_signals = /** @type {(inputs: Intent_SignalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إشارات النوايا`)
};

const id_intent_signals = /** @type {(inputs: Intent_SignalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sinyal Niat`)
};

const it_intent_signals = /** @type {(inputs: Intent_SignalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segnali di Intenzione`)
};

const ru_intent_signals = /** @type {(inputs: Intent_SignalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сигналы намерений`)
};

const pt_intent_signals = /** @type {(inputs: Intent_SignalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sinais de Intenção`)
};

const ko_intent_signals = /** @type {(inputs: Intent_SignalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`의도 시그널`)
};

/**
* | output |
* | --- |
* | "Intent Signals" |
*
* @param {Intent_SignalsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const intent_signals = /** @type {((inputs?: Intent_SignalsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intent_SignalsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_intent_signals(inputs)
	if (locale === "es") return es_intent_signals(inputs)
	if (locale === "fr") return fr_intent_signals(inputs)
	if (locale === "de") return de_intent_signals(inputs)
	if (locale === "ja") return ja_intent_signals(inputs)
	if (locale === "zh") return zh_intent_signals(inputs)
	if (locale === "ar") return ar_intent_signals(inputs)
	if (locale === "id") return id_intent_signals(inputs)
	if (locale === "it") return it_intent_signals(inputs)
	if (locale === "ru") return ru_intent_signals(inputs)
	if (locale === "pt") return pt_intent_signals(inputs)
	return ko_intent_signals(inputs)
});